/**
 * Email helpers matching the backend's principal email rules.
 */

// RFC 5321 caps a forward path at 254 characters.
const MAX_LENGTH = 254

// Domain labels exclude dots, so no two parts of the pattern can match the same characters and a
// long hostile value fails in linear time.
const EMAIL_PATTERN = /^[^@\s]+@[^@\s.]+(?:\.[^@\s.]+)+$/

/**
 * Whether `value` has an email shape (local part, `@`, dotted domain) and fits the 254-character
 * limit.
 */
export function isValidEmail(value: string): boolean {
  return value.length <= MAX_LENGTH && EMAIL_PATTERN.test(value)
}

/**
 * Whether two emails name the same person, ignoring case and surrounding whitespace.
 */
export function sameEmail(a: string, b: string | undefined): boolean {
  return !!b && a.trim().toLowerCase() === b.trim().toLowerCase()
}
